<template>
  <div class="e-commerce-tab-wrapper">
    <div class="field">
      <div class="label">
        <label>Payment</label>
      </div>
      <div class="form-control">
        <div class="form-group">
          <p class="" v-if="!stripeInfoExist">
            Manage billing and payments for all orders on your site with Stripe.
          </p>
          <div class="account-status" v-if="stripeInfoExist">
            <div class="connection-status">
              <span> Status</span>
            </div>

            <div class="details-toggle">
              <img v-if="stripeErrors.show" src="../../assets/close-x.svg" />
              <img v-else src="../../assets/green-tick.svg" />
              <span>{{
                stripeErrors.show
                  ? 'Not connected with Stripe'
                  : 'Connected with Stripe '
              }}</span>
            </div>
          </div>

          <div class="stripe-errors" v-if="stripeErrors.show">
            <div>
              <img src="../../assets/warning.svg" />
            </div>
            <div>
              <p>
                <span
                  >Please update the following missing information on Stripe and
                  try again.</span
                >
              </p>

              <ul class="stripe-error-list list-disc">
                <li v-for="(error, i) in stripeErrors.errors" :key="i">
                  {{ error.replace('_', ' ').replace('.', ' ') }}
                </li>
                <li class="resolve-errors-cta">Resolve issues</li>
              </ul>
            </div>
          </div>

          <transition>
            <div class="stripe-details" v-if="stripeInfo">
              <div>
                <div class="row">
                  <div>Account Type</div>
                  <div>{{ stripeInfo.type }}</div>
                </div>

                <div class="row">
                  <div>Account Status</div>
                  <div>
                    {{
                      stripeInfo.verification.disabledReason
                        ? 'Not Connected'
                        : 'Connected'
                    }}
                  </div>
                </div>

                <div class="row">
                  <div>Display Name</div>
                  <div>{{ stripeInfo.displayName }}</div>
                </div>

                <div class="row">
                  <div>Email</div>
                  <div>{{ stripeInfo.email }}</div>
                </div>
                <div class="row">
                  <div>Country</div>
                  <div>{{ stripeInfo.country }}</div>
                </div>

                <div class="row">
                  <div>Managed</div>
                  <div>{{ stripeInfo.managed }}</div>
                </div>

                <div class="row">
                  <div>Business URL</div>
                  <div>{{ stripeInfo.businessUrl }}</div>
                </div>

                <div class="row">
                  <div>Support URL</div>
                  <div>{{ stripeInfo.supportUrl }}</div>
                </div>
              </div>
            </div>
          </transition>
          <button
            @click="connectStripe"
            :disabled="stripeButtonLoading"
            v-if="stripeErrors.show || !stripeInfoExist"
            class="button-gemnote button-gemnote--small connect-stripe"
          >
            <img
              v-if="stripeButtonLoading"
              src="../../assets/loading-white.svg"
            />
            <span v-if="!stripeInfoExist">CONNECT WITH </span>
            <span v-else>Update using </span>
            <img src="../../assets/stripe-logo.svg" />
          </button>
          <button
            @click="connectStripe"
            v-if="stripeInfoExist && !stripeErrors.show"
            class="whitebutton-gemnote button-gemnote-glass--tiny w-max"
          >
            <span>DISCONNECT STRIPE </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { status } from '@/helpers'
let bodyFormData = new FormData()
export default {
  name: 'EcommercePaymentsTab',

  data() {
    return {
      updatingStore: false,
      showStripeDetails: false
    }
  },

  computed: {
    ...mapState({
      connectingStripe: state => state.ecommerce.connectingStripe,
      shopDetails: state => state.ecommerce.shopDetails,
      team: state => state.team.team
    }),
    stripeButtonLoading() {
      return this.connectingStripe || this.creatingStore
    },
    stripeInfoExist() {
      return !!this.shopDetails.stripeAccountBlob
    },
    shopExist() {
      return !!this.shopDetails.id
    },
    stripeInfo() {
      return this.shopDetails.stripeAccountBlob
    },
    stripeErrors() {
      if (this.shopDetails.stripeAccountBlob) {
        if (this.shopDetails.stripeAccountBlob.verification.disabledReason) {
          return {
            show: true,
            errors: this.shopDetails.stripeAccountBlob.verification.fieldsNeeded
              .length
              ? this.shopDetails.stripeAccountBlob.verification.fieldsNeeded
              : this.shopDetails.stripeAccountBlob.verification.errors
          }
        }
      }
      return {
        show: false,
        errors: []
      }
    }
  },
  methods: {
    async connectStripe() {
      console.log(this.shopExist)
      if (this.shopExist) {
        await this.updateStoreInfo()
        if (this.updatingShop !== status.ERROR) {
          await this.$store.dispatch('ecommerce/connectStripe')
        }
      } else {
        await this.createStore()
        if (this.creatingStore !== status.ERROR) {
          await this.$store.dispatch('ecommerce/connectStripe')
        }
      }
    },
    async createStore() {
      bodyFormData.set('e_commerce_store[paige_team_id]', this.team.id)
      bodyFormData.set('e_commerce_store[title]', this.shopDetails.title)
      bodyFormData.set(
        'e_commerce_store[description]',
        this.shopDetails.description
      )
      bodyFormData.set('e_commerce_store[primary_color]', '#000000')
      bodyFormData.set('e_commerce_store[secondary_color]', '#000000')
      bodyFormData.set(
        'e_commerce_store[out_of_stock]',
        this.shopDetails.outOfStock ? true : false
      )

      await this.$store.dispatch('ecommerce/createStore', bodyFormData)
    },
    async updateStoreInfo(shouldNotify = true) {
      this.updatingStore = true
      let newStoreLogo = bodyFormData.get('e_commerce_store[logo_file]')
      if (newStoreLogo === null) {
        bodyFormData.delete('e_commerce_store[logo_file]')
      }

      let newBanner = bodyFormData.get('e_commerce_store[banner_file]')
      if (newBanner === null) {
        bodyFormData.delete('e_commerce_store[banner_file]')
      }

      bodyFormData.set('e_commerce_store[title]', this.shopDetails.title)
      bodyFormData.set(
        'e_commerce_store[description]',
        this.shopDetails.description
      )
      bodyFormData.set(
        'e_commerce_store[primary_color]',
        this.shopDetails.primaryColor
          ? this.shopDetails.primaryColor
          : '#000000'
      )

      bodyFormData.set(
        'e_commerce_store[out_of_stock]',
        this.shopDetails.outOfStock
      )

      bodyFormData.set(
        'e_commerce_store[showingDefaultDescription]',
        Boolean(this.shopDetails.showingDefaultDescription)
      )

      bodyFormData.set(
        'e_commerce_store[custom_domain]',
        this.shopDetails.customDomain
      )

      bodyFormData.append('shouldNotify', shouldNotify)
      this.updatingStore = false
      return this.$store.dispatch('ecommerce/editStore', bodyFormData)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.e-commerce-tab-wrapper {
  border-radius: 29px;
  padding: 3rem 4rem;
  background: inherit;
  border: 1px solid #000;
  min-height: 70vh;
  overflow: hidden;
}

.field {
  display: flex;
  flex-direction: row;
  margin: 25px 0;
  gap: 20px;

  .label {
    width: 10%;
    text-align: left !important;
    display: flex;
    flex-direction: column;

    span {
      color: rgba(37, 40, 42, 0.5);
      font-size: 0.688rem;
      font-style: italic;
      font-weight: 100;
    }

    label {
      display: inline !important;
      text-align: left;
      font-size: 0.813rem;
      font-weight: bold;
    }
  }
}

.form-control {
  p {
    font-size: 0.813rem;
  }
}

.connect-stripe {
  text-transform: unset;
  margin-top: 22px;
  display: flex;
  font-weight: lighter;
  height: 2.5rem;
  width: auto;

  span {
    font-size: 0.813rem;
    font-weight: 300;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:hover,
  &:focus {
    background-color: #635bfe;
    border: #635bfe;
  }
}

.stripe-details {
  background: #dfdad2;
  border: none;
  width: 550px;
  margin: 20px 0;

  & > div {
    width: 100%;
    padding: 20px;

    .row {
      display: flex;
      gap: 10px;
      padding: 5px 0;
      height: unset !important;
      margin: 5px 0;

      & > div:first-child {
        width: 20%;
        font-weight: 700;
      }

      & > div {
        width: 50%;
        font-size: 0.688rem;
        color: #514d43;
        font-weight: 400;
        text-align: left;
        line-break: anywhere;
      }
    }
  }
}

.error-msg {
  color: #da5737;
  font-size: 10px;
  line-height: 14px;
  display: block;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 20px;

  span {
    font-size: 0.813rem;
    font-weight: bold;
  }
}

.account-status {
  margin-bottom: 30px;
  display: flex;
  gap: 20px;

  .details-toggle {
    display: flex;
    align-items: center;
    gap: 10px;

    span {
      // text-decoration: underline;
      font-size: 0.813rem;
      cursor: pointer;
    }
  }
}

.stripe-errors {
  background: $main-white;
  padding: 0 1.5rem;
  border: 1px solid #232220;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-top: 24px;
  gap: 10px;

  p {
    padding-top: 4px;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 10px;

    span {
      font-size: 0.813rem;
    }
  }

  ul {
    padding-bottom: 24px;
    margin-top: 20px;
    text-transform: capitalize;

    li {
      font-size: 0.688rem;
      color: #da5737;
      padding: 5px;
      margin: 2px;
      line-height: normal;
      text-align: left;
      list-style-type: none;

      &.resolve-errors-cta {
        color: $main-6;
        font-weight: bold;
        text-decoration: underline;
        font-size: 0.813rem;
        cursor: pointer;
        margin-top: 10px;
      }
    }
  }
}

.w-max {
  width: max-content;
}

@media (max-width: 568px) {
  .e-commerce-tab-wrapper {
    padding: 1.5rem;
  }

  .field {
    flex-direction: column;
  }
}
</style>
